<!--美育浸润-子类视频列表-->
<template>
    <div class="guide-ext-container" v-loading="loading">
        <div class="museum-title-container">
            <div class="l-museum-title-container">
                <div class="l-t-museum-title-container">{{itemName}}</div>
                <div class="l-b-museum-title-container">视频列表</div>
            </div>
            <div class="r-museum-title-container">
                <input class="search-input" type="text" placeholder="请输入关键词" v-model="searchKeyword"/>
                <div class="back-btn-container" @click="backPage">⇦返回</div>
            </div>
        </div>

        <!-- 视频卡片 -->
        <div class="video-card-container">
            <div class="video-card" v-for="(item,index) in filteredList" :key="index" @click="handleCardClick(item)">
                <div class="card-cover">
                    <img :src="item.coverUrl" :alt="item.title"/>
                    <div class="video-badge">视频</div>
                </div>
                <div class="card-title" :title="item.title">{{item.title}}</div>
            </div>
            <div class="empty-container" v-if="!loading && filteredList.length===0">
                <dataEmpty title="暂无数据"/>
            </div>
        </div>
    </div>
</template>

<script>
import {listHumVideo} from "@/api/admin/museum";
import dataEmpty from "@/components/dataEmpty.vue";

export default {
    name: "beautyVideoList",
    components: {dataEmpty},
    data() {
        return {
            loading:false,
            searchKeyword:'',
            videoList:[],
        }
    },
    computed: {
        filteredList() {
            const keyword = this.searchKeyword.trim();
            if (!keyword) return this.videoList;
            return this.videoList.filter(item => {
                const name = item.videoName || item.videoTitle || item.title || "";
                return name.includes(keyword);
            });
        }
    },
    props:{
        itemId:{
            type: [String,Number],
            default:null
        },
        itemName:{
            type: String,
            default:''
        },
        markInfo:{
            type: String,
            default:null
        },
    },
    watch: {
        markInfo(newValue,oldValue){
            this.searchKeyword = '';
            this.queryVideoList();
        },
    },
    created() {
        this.queryVideoList();
    },
    mounted(){},
    methods: {
        /*查询子类视频列表*/
        queryVideoList(){
            if (!this.itemId) return;
            this.loading = true;
            listHumVideo({itemId:this.itemId}).then(res => {
                if (res.data.code===1){
                    this.videoList = res.data.data || [];
                }else {
                    this.$message.error(res.data.msg || "请求出错");
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            })
        },
        handleCardClick(item){
            this.$emit('view-video-info', item);
        },
        backPage(){
            this.$emit('back-model-page', 'beautyClassify');
        }
    }
}
</script>

<style scoped>
.guide-ext-container{
    width: 100%;
    height: calc(100vh - 174px);
    background: #ffffff;
    border-radius: 16px;
    padding: 20px 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}
.museum-title-container{
    flex-shrink: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 14px;
    padding: 0 28px;
    box-sizing: border-box;
}
.l-museum-title-container{
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.l-t-museum-title-container{
    font-weight: bold;
    color: #ff7f2e;
    font-size: 18px;
    line-height: 1.4;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.l-b-museum-title-container{
    color: #9a9a9a;
    font-size: 14px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.r-museum-title-container{
    width: auto;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 10px;
}
.back-btn-container{
    flex-shrink: 0;
    height: 32px;
    padding: 0 14px;
    background: #ff7f2e;
    color: #fff;
    line-height: 32px;
    text-align: center;
    font-size: 14px;
    border-radius: 6px;
    cursor: pointer;
    white-space: nowrap;
}

/* 搜索框 */
.search-input{
    flex-shrink: 0;
    width: 200px;
    height: 32px;
    line-height: 32px;
    padding: 0 12px;
    border: 1px solid #d1d5db;
    border-radius: 6px;
    outline: none;
    font-size: 14px;
    box-sizing: border-box;
    background-color: #ffffff;
}
.search-input:focus{
    border-color: #ff7f2e;
}

/* 视频卡片 */
.video-card-container{
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    gap: 20px;
    padding: 10px 28px;
    box-sizing: border-box;
}
.video-card{
    width: calc(20% - 16px);
    flex-shrink: 0;
    background-color: #ffffff;
    border: 1.5px solid #ff7f2e;
    border-radius: 6px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    transition: all 0.25s ease;
    overflow: hidden;
}
.video-card:hover{
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0,0,0,0.1);
}
.card-cover{
    width: 100%;
    height: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background-color: #f3f4f6;
    position: relative;
}
.card-cover img{
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.video-badge{
    position: absolute;
    right: 8px;
    bottom: 8px;
    padding: 2px 8px;
    background-color: rgba(0,0,0,0.5);
    color: #ffffff;
    font-size: 12px;
    border-radius: 3px;
}
.card-title{
    width: 100%;
    min-height: 46px;
    line-height: 22px;
    padding: 10px 12px;
    font-size: 15px;
    color: #1f2937;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    box-sizing: border-box;
}
.empty-container{
    width: 100%;
}
</style>
